var _path, _polygon, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAdmindash(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path--inject-15--inject-140"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M246.64,199.13l48.48-28c.87-.5,1.57-.1,1.57.91v61.71a3.46,3.46,0,0,1-1.57,2.72l-48.48,27.94c-.87.5-1.57.1-1.57-.9V201.85A3.46,3.46,0,0,1,246.64,199.13Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-2--inject-15--inject-140"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M246.64,93.91l48.48-28c.87-.5,1.57-.1,1.57.91v61.71a3.46,3.46,0,0,1-1.57,2.72L246.64,159.2c-.87.5-1.57.1-1.57-.91V96.63A3.46,3.46,0,0,1,246.64,93.91Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-3--inject-15--inject-140"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M181,237l48.49-28c.87-.5,1.57-.1,1.57.91v61.71a3.46,3.46,0,0,1-1.57,2.72L181,302.33c-.87.5-1.58.1-1.58-.91V239.76A3.49,3.49,0,0,1,181,237Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-4--inject-15--inject-140"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M181,131.81l48.49-28c.87-.5,1.57-.09,1.57.91v61.71a3.47,3.47,0,0,1-1.57,2.73L181,197.11c-.87.5-1.58.09-1.58-.91V134.54A3.49,3.49,0,0,1,181,131.81Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-5--inject-15--inject-140"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.21,275l48.48-28c.87-.51,1.58-.1,1.58.9v61.72a3.48,3.48,0,0,1-1.58,2.72l-48.48,27.94c-.87.5-1.57.1-1.57-.91V277.72A3.46,3.46,0,0,1,115.21,275Z",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-6--inject-15--inject-140"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M115.21,169.78l48.48-28c.87-.51,1.58-.1,1.58.9v61.72a3.48,3.48,0,0,1-1.58,2.72l-48.48,27.94c-.87.5-1.57.09-1.57-.91V172.5A3.46,3.46,0,0,1,115.21,169.78Z",
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-15--inject-140"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--floor--inject-15--inject-140",
    cx: 249.05,
    cy: 363.55,
    rx: 221.3,
    ry: 114.92,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-15--inject-140"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--shadow--inject-15--inject-140",
    cx: 403.41,
    cy: 390.32,
    rx: 49.59,
    ry: 30.13,
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-15--inject-140"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--plants--inject-15--inject-140"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.32,364.06a59,59,0,0,0-4-17C79.78,338.3,73,329.48,65.1,327.81s-11.19,3.62-9.53,8.82c1.43,4.47,7.27,8.18,11.7,12.09s12.72,13.33,15,22.45l4.43.48Z",
    style: {
      fill: "#28A745"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.15
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M87.32,364.06a59,59,0,0,0-4-17C79.78,338.3,73,329.48,65.1,327.81s-11.19,3.62-9.53,8.82c1.43,4.47,7.27,8.18,11.7,12.09s12.72,13.33,15,22.45l4.43.48Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M84.3,368.17a.5.5,0,0,1-.5-.48C83,344.78,60.57,332,60.34,331.84a.49.49,0,1,1,.48-.86c.23.13,23.12,13.22,24,36.68a.49.49,0,0,1-.48.51Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.55,399.49s-4.58,2.89-11.74,1.66a11,11,0,0,1-6.16-3c-1.85-1.91-2.14-3.82-2.66-6.37a7.66,7.66,0,0,0-1.08-3c-1.53-2.11-4.59-2.07-7.14-2.62a10.6,10.6,0,0,1-8-6.93c-1.05-3.56.65-7.89,4.08-9.28l-4.2-2.69A18.37,18.37,0,0,1,44,364.53a6.2,6.2,0,0,1-1.81-4,5.94,5.94,0,0,1,3.7-5.15,12.59,12.59,0,0,1,6.59-.67,29.3,29.3,0,0,1,6.58,1.55,4.7,4.7,0,0,0,1.84.41,4.86,4.86,0,0,0,2.25-1c4.81-3.18,12.66-2.94,15.24,3.06.38.88.61,1.82,1,2.69,1.5,3.23,5.71,2.26,8.43,3.77A6.87,6.87,0,0,1,91,370c.54,3.2-.35,6.84-.94,10s-1.34,6.08-2.2,9.08c-.7,2.46-1.47,4.91-2.29,7.34C85.43,397,85.05,399.17,84.55,399.49Z",
    style: {
      fill: "#28A745"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.43,392.1a44.12,44.12,0,0,0-11.5-17.32.49.49,0,0,0-.26-.25c-1.52-1.42-3.09-2.74-4.67-3.95A23.73,23.73,0,0,1,72.59,358a.49.49,0,0,0-.24-.66.48.48,0,0,0-.65.24,24.52,24.52,0,0,0-1.82,12.13,75.71,75.71,0,0,0-21.67-10.86.5.5,0,0,0-.26,1A73.4,73.4,0,0,1,73.67,374c-7.07-1.23-15.52,2.18-15.91,2.34a.5.5,0,0,0-.27.65.49.49,0,0,0,.46.3l.18,0c.1,0,10-4.06,17-1.88a43.24,43.24,0,0,1,11.33,17,.51.51,0,0,0,.47.33.45.45,0,0,0,.16,0A.49.49,0,0,0,87.43,392.1Z",
    style: {
      fill: "#fff"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Board--inject-15--inject-140"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "98.49 388.04 307.54 267.35 307.54 46.05 98.49 166.75 98.49 388.04",
    style: {
      fill: "#28A745"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "88.84 161.18 98.49 166.75 307.54 46.05 317.18 29.34 88.84 161.18",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "317.18 272.92 317.18 29.34 307.54 46.05 307.54 267.35 317.18 272.92",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "88.84 161.18 98.49 166.75 98.49 388.04 88.84 404.75 88.84 161.18",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "98.49 388.04 307.54 267.35 317.18 272.92 88.84 404.75 98.49 388.04",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "88.84 161.18 98.49 166.75 307.54 46.05 317.18 29.34 88.84 161.18",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "98.49 388.04 307.54 267.35 317.18 272.92 88.84 404.75 98.49 388.04",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "317.18 29.34 310.75 25.63 82.41 157.46 88.84 161.18 317.18 29.34",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "82.41 157.46 88.84 161.18 88.84 404.75 82.41 401.04 82.41 157.46",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1,
      mixBlendMode: "multiply"
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "307.54 46.05 304.32 47.91 304.32 265.49 98.49 384.32 98.49 388.04 307.54 267.35 307.54 46.05"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--characters-boxes--inject-15--inject-140"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M296.3,174l-.06-2.93-3.48-2h0a1.09,1.09,0,0,0-1.11.11l-48.49,28a3.49,3.49,0,0,0-1.57,2.72v61.66a1.11,1.11,0,0,0,.45,1h0l3.49,2v-3.47l46.11-26.57a3.46,3.46,0,0,0,1.57-2.72V174Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.24,171l-3.48-2h0a1.09,1.09,0,0,0-1.11.11l-48.49,28a3.12,3.12,0,0,0-1,1L247.1,201l46.12-26.05Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.64,199.13l48.48-28c.87-.5,1.57-.1,1.57.91v61.71a3.46,3.46,0,0,1-1.57,2.72l-48.48,27.94c-.87.5-1.57.1-1.57-.9V201.85A3.46,3.46,0,0,1,246.64,199.13Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path--inject-15--inject-140)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-boy--inject-15--inject-140"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M280.52,225.21s3.81-1.18,7,3.83c2.16,3.4,9.7,16.33,9.7,16.33s14.67-7.78,15.49-8.8.78-3.08.9-4.19a12.16,12.16,0,0,0-.57-4.13c-.17-1.17,1.51-1.23,2.34.39.6,1.18.65,2.53,1.17,2.55a14.57,14.57,0,0,0,2.06-1.75c.91-1,2.55-2.66,3.8-2.43a1.08,1.08,0,0,1,.83.89,5.75,5.75,0,0,0,.46,2,3.24,3.24,0,0,1,.49.8,7,7,0,0,1,0,1.29c0,.61.65.87.73,1.47.06.43-.16.93-.15,1.39,0,.29.09.55.09.85a2.82,2.82,0,0,1-.75,1.63,17.47,17.47,0,0,1-4.36,3.65c-1.34.87-3.1,1.65-4.61,2.47S296.31,257.51,294,256s-13.84-18.38-13.84-18.38C277.52,230.15,280.52,225.21,280.52,225.21Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.82,225.32s4.2-1.7,6.93-1.53,4.74,1,6.74,4.17c2.67,4.28,7.08,11.69,7.08,11.69a21.32,21.32,0,0,1-8.58,9.18l-8.13-12.28Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-boy--inject-15--inject-140"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M260.5,232.74a9,9,0,0,0-3,4.37,21.2,21.2,0,0,0-.91,6.39v13.95l-.17,26.4c8.85,3,20.1.36,29.54-10.14,0,0-.52-33.76-.52-39.31,0-.25,0-.5,0-.76-.34-7.83-7.1-11.45-13.75-7.7l-5.59,3.16-5.61,3.64Z",
    style: {
      fill: "#28A745"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.5,232.74a9,9,0,0,0-3,4.37,21.2,21.2,0,0,0-.91,6.39v13.95l-.17,26.4c8.85,3,20.1.36,29.54-10.14,0,0-.52-33.76-.52-39.31,0-.25,0-.5,0-.76-.34-7.83-7.1-11.45-13.75-7.7l-5.59,3.16-5.61,3.64Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.68,201.26c-1-1-1.62-2.55-.43-3.7a1.91,1.91,0,0,1,1-.58c.48-.07.91,0,1.39-.12s1.11-.22,1.65-.38a10.92,10.92,0,0,0,3-1.4.33.33,0,0,1,.25-.08c.1,0,.15.15.17.26a5.92,5.92,0,0,1-2.63,5.85,5,5,0,0,1-2.23.88A2.83,2.83,0,0,1,279.68,201.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.69,213.45s1.37,7.09,1.92,8.17a2.1,2.1,0,0,0,1.69,1.12l-.09-5.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.41,202.3a3.85,3.85,0,0,0-2.63,1.78c-1.14,1.64-.5,5.65.91,9.37l2.58-.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.05,212.9c-.52.49-1.26-.46-1.9-1.06s-2.73-1.1-3.77,1.71.92,5.76,2.56,5.92c2.84.26,3.27-1.95,3.27-1.95l.09,12.11c4.76,5,13.1-.91,9.35-3.14V222.9a16.45,16.45,0,0,0,3.83-.8c2.08-.93,3.39-3.18,4-6,1-4.46.92-7.11.58-15.15-.23-5.52-10.08-7.23-15-2.35S265.05,212.9,265.05,212.9Z",
    style: {
      fill: "#b17a7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.05,213.9c-.26.08-1.25-1.56-1.9-2.06-.89-.7.26-9.54.26-9.54-1-2.27.87-5.71,2.87-7.11a11.65,11.65,0,0,1,4.73-1.74c2-.36,3.95-.58,5.95-.79a20.68,20.68,0,0,0,3.22-.57,26.67,26.67,0,0,0,2.95-1.18,1.17,1.17,0,0,1,.89-.11c1.19.54.41,3.38.14,4.31a10.49,10.49,0,0,1-2.35,4.24,6.42,6.42,0,0,1-1.24,1.09,8.17,8.17,0,0,1-1.77.83,23.17,23.17,0,0,1-9,1.31,4,4,0,0,0-1.7.13c-1.24.5-1.18,2.65-1.37,3.75C266.31,209.17,265.93,213.65,265.05,213.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.42,203l-3.14-1.11a2.08,2.08,0,0,1,2.37-1.54C263.52,200.62,263.86,201.81,263.42,203Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.64,222.9s-4.65.16-6.28-.4a4,4,0,0,1-2.25-2,6.82,6.82,0,0,0,1.28,2.69c1.19,1.44,7.25,1.11,7.25,1.11Z",
    style: {
      fill: "#9a585a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.05,210.47a1.43,1.43,0,0,1-.93,1.37c-.51.13-.93-.26-.93-.88a1.43,1.43,0,0,1,.93-1.36C273.64,209.46,274.05,209.85,274.05,210.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.71,207.33l-2,1.8a1.76,1.76,0,0,1,.47-1.95A.92.92,0,0,1,272.71,207.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.22,216.54l2.13.35a1.46,1.46,0,0,1-1.45,1.2C274.32,218,274,217.3,274.22,216.54Z",
    style: {
      fill: "#9a585a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.31,206l-1.82-1.13c.37-.7,1.08-1,1.58-.7A1.4,1.4,0,0,1,282.31,206Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.81,208.08a1.43,1.43,0,0,1-.93,1.37c-.51.14-.93-.25-.93-.87a1.45,1.45,0,0,1,.93-1.37C281.4,207.08,281.81,207.47,281.81,208.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "277.2 208.46 277.31 214.96 280.66 213.21 277.2 208.46",
    style: {
      fill: "#9a585a"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M247.33,272.65c2-26.89,5.94-36.53,12.49-39.36,2.27,1.69,2.81,9.59.45,15.59,0,0-5.09,17.93-5.38,24a98.11,98.11,0,0,0,1,17,2.44,2.44,0,0,0,1,1.69c1.44.93,1.34,2.28,2.37,3.57.8,1,1.55,1.17,1.39,1.55a1.77,1.77,0,0,1-2,1.07,5.53,5.53,0,0,1-1.76-1,14.43,14.43,0,0,0,1.85,4c1.86,2.84,1.77,4.76-2.6,5.41-2.74.4-4.73-1.3-6.11-8.16-.4-2-1.33-5.54-1.72-8.1A79.26,79.26,0,0,1,247.33,272.65Z",
    style: {
      fill: "#b17a7b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.69,232s-4.78,1.67-7.19,5.58-4.7,10.19-6.32,21.35c0,0,3,4.13,10.9.7,0,0,3.42-14.24,3.73-19.87C263.14,233.59,261.69,232,261.69,232Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M296.3,247.71l-.06-2.93-3.48-2h0a1.09,1.09,0,0,0-1.11.11l-48.49,28a3.49,3.49,0,0,0-1.57,2.72v14.44a1.1,1.1,0,0,0,.45,1h0l3.49,2V287.6L291.65,261a3.46,3.46,0,0,0,1.57-2.72v-10.6Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.24,244.78l-3.48-2h0a1.09,1.09,0,0,0-1.11.11l-48.49,28a3.12,3.12,0,0,0-1,1l4.93,2.85,46.12-26.05Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.64,272.88l48.48-28c.87-.5,1.57-.09,1.57.91v14.49a3.45,3.45,0,0,1-1.57,2.72L246.64,291c-.87.5-1.57.09-1.57-.91V275.61A3.47,3.47,0,0,1,246.64,272.88Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--stars--inject-15--inject-140"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M251.25,274.23l.89,1.87a.21.21,0,0,0,.28.12l2-.76c.31-.12.43.32.21.75l-1.43,2.68a.88.88,0,0,0-.11.51l.34,2.42c.05.39-.28.9-.56.86l-1.76-.22a.46.46,0,0,0-.36.21L249,284.92c-.28.36-.61.23-.56-.21l.34-2.82a.4.4,0,0,0-.11-.38l-1.43-1c-.22-.16-.1-.74.22-1l2-1.52a.94.94,0,0,0,.29-.44l.88-2.89C250.71,274.17,251.11,273.93,251.25,274.23Z",
    style: {
      fill: "#28A745"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.24,268.51l.88,1.88a.21.21,0,0,0,.29.11l2-.76c.31-.12.44.32.21.75l-1.43,2.68a.89.89,0,0,0-.11.51l.34,2.43c.05.38-.27.89-.55.85l-1.77-.21a.41.41,0,0,0-.35.2L259,279.21c-.28.36-.6.23-.55-.22l.34-2.81a.41.41,0,0,0-.11-.39l-1.43-1c-.23-.17-.1-.75.21-1l2-1.52a1,1,0,0,0,.29-.45l.88-2.89C260.69,268.45,261.1,268.22,261.24,268.51Z",
    style: {
      fill: "#28A745"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.22,262.8l.88,1.87a.21.21,0,0,0,.29.11l2-.75c.32-.12.44.32.22.74l-1.43,2.68a.91.91,0,0,0-.11.52l.34,2.42c.05.39-.28.89-.56.86l-1.76-.22a.44.44,0,0,0-.36.21l-1.76,2.25c-.28.36-.61.23-.56-.22l.34-2.81a.42.42,0,0,0-.11-.39l-1.43-1c-.22-.16-.1-.75.22-1l2-1.52a1,1,0,0,0,.29-.44l.88-2.9C270.68,262.73,271.08,262.5,271.22,262.8Z",
    style: {
      fill: "#28A745"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.21,257.08l.88,1.87a.22.22,0,0,0,.29.12l2-.76c.31-.12.44.32.21.75l-1.43,2.68a.88.88,0,0,0-.11.51l.34,2.42c.05.39-.27.9-.55.86l-1.77-.22a.45.45,0,0,0-.35.21l-1.77,2.25c-.28.36-.61.23-.55-.21l.33-2.82a.38.38,0,0,0-.11-.38l-1.42-1c-.23-.17-.1-.75.21-1l2-1.52a.88.88,0,0,0,.29-.44l.88-2.89C280.66,257,281.07,256.78,281.21,257.08Z",
    style: {
      fill: "#28A745"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.19,251.36l.88,1.88a.21.21,0,0,0,.29.11l2-.76c.32-.12.44.32.21.75L293.12,256a.89.89,0,0,0-.11.51l.33,2.43c.06.38-.27.89-.55.86L291,259.6a.41.41,0,0,0-.36.2l-1.76,2.26c-.28.36-.61.23-.56-.22l.34-2.81a.41.41,0,0,0-.11-.39l-1.43-1c-.22-.17-.1-.75.21-1l2-1.52a.94.94,0,0,0,.28-.45l.89-2.89C290.65,251.3,291.05,251.07,291.19,251.36Z",
    style: {
      fill: "#28A745"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M296.3,68.74l-.06-2.93-3.48-2h0a1.09,1.09,0,0,0-1.11.11l-48.49,28a3.49,3.49,0,0,0-1.57,2.72v61.66a1.11,1.11,0,0,0,.45,1h0l3.49,2v-3.47l46.11-26.57a3.46,3.46,0,0,0,1.57-2.72V68.74Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.24,65.81l-3.48-2h0a1.09,1.09,0,0,0-1.11.11l-48.49,28a3.12,3.12,0,0,0-1,1l4.93,2.85,46.12-26Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.64,93.91l48.48-28c.87-.5,1.57-.1,1.57.91v61.71a3.46,3.46,0,0,1-1.57,2.72L246.64,159.2c-.87.5-1.57.1-1.57-.91V96.63A3.46,3.46,0,0,1,246.64,93.91Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-2--inject-15--inject-140)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-15--inject-140"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M284.1,157.54c-5.44-23.86-11.66-28.07-5.85-33,6-2.28,9.06,1,10.1,8,.51,3.42,1.62,17.72,3,23.07,1.22,4.7,2.86,10.52,4.69,13.88a2,2,0,0,0,1.5,1c1.7.25,2.2,1.2,3.59,1.91,1.08.55,1.88.41,1.83.79a2.15,2.15,0,0,1-1.71,1.7,5.93,5.93,0,0,1-2-.14,11.29,11.29,0,0,0,3,2.72c2.66,1.72,3.1,3.41-1.13,5.66-2.64,1.41-5.12.72-8.4-4.65a42.79,42.79,0,0,1-3.31-6.22C287.07,166.42,285,161.38,284.1,157.54Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.25,124.5s2.79-1.31,4.83-.87,4.56,2.11,5.45,8.49c0,0-.54,2-3.4,4Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.69,127.38h0c-5.92,2.05-6.33,5.46-7.81,9.47a13.63,13.63,0,0,0-.28,8.87l4.12,12.66A85.49,85.49,0,0,0,260.55,170c10.34,3.9,23.26-3.07,26.37-8.76.13-1.07-.67-8.92-1.16-14.06,1.82-5.76,2.3-9.23,1.53-12.51-1.43-6.1-7-10.92-9.41-10Z",
    style: {
      fill: "#28A745"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.69,127.38h0c-5.92,2.05-6.33,5.46-7.81,9.47a13.63,13.63,0,0,0-.28,8.87l4.12,12.66A85.49,85.49,0,0,0,260.55,170c10.34,3.9,23.26-3.07,26.37-8.76.13-1.07-.67-8.92-1.16-14.06,1.82-5.76,2.3-9.23,1.53-12.51-1.43-6.1-7-10.92-9.41-10Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.72,119.23l-4.36,1.19c-6.08,1.65-11-2.68-11.05-9.69h0c0-8.4,5.85-16.82,13.13-18.8h0c7.27-2,13.2,3.21,13.23,11.61h0C286.7,110.54,281.79,117.57,275.72,119.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270,89.27c1.88,2.69-.11,5.41-2.88,8.33s-5.27,4.92-7.15,2.23-.85-6.55,1.92-9.46S268.14,86.57,270,89.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.24,101l-2.79,3.13a2.28,2.28,0,0,1,.3-2.87A1.63,1.63,0,0,1,263.24,101Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.58,96.52c1.4.57,3.13,4.14,3,12.66-.12,7.21-2.13,9.54-3.14,10.32s-3,1-4.87,1.16l.11,4.34s3.2,2.17,3,4.19-4.43,4.08-6.89,2.82a20.74,20.74,0,0,1-4.44-3.23.37.37,0,0,1-.1-.27V117.64s-1.12,1.55-3,.16a4.08,4.08,0,0,1-.89-5.43c1.21-1.76,3.47-2,4.34-.18,0,0,3-.7,7-4.36A18.22,18.22,0,0,0,281.58,96.52Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277,109.18a1.23,1.23,0,0,1-.74,1.18c-.43.14-.8-.16-.82-.67a1.2,1.2,0,0,1,.73-1.18C276.56,108.36,276.92,108.66,277,109.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.85,115.29l1.82.18a1.25,1.25,0,0,1-1.18,1.07C278,116.49,277.71,115.94,277.85,115.29Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284,104.75l-1.59-.84c.29-.6.87-.9,1.31-.67A1.15,1.15,0,0,1,284,104.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.8,107a1.21,1.21,0,0,1-.73,1.18c-.44.14-.81-.16-.83-.67a1.23,1.23,0,0,1,.74-1.18C283.41,106.13,283.78,106.43,283.8,107Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "280.15 106.96 280.12 112.85 282.6 111.29 280.15 106.96",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.07,105.62c-.21-1.41-1.6-2-3.08-1.57l-.14,0a4.29,4.29,0,0,0-2.51,2.27,1.9,1.9,0,0,0-1.48,0,3.79,3.79,0,0,0-1.29.84,2.4,2.4,0,0,0-2.65-.59l-.14,0a4.2,4.2,0,0,0-2.77,3.13l-4.86,1.6a2.46,2.46,0,0,1,.33.37l4.5-1.49a2.1,2.1,0,0,0,2.95,2l.43-.14a3.87,3.87,0,0,0,2.64-3.92,2.19,2.19,0,0,0-.2-.61,2.87,2.87,0,0,1,1.11-.75,1.39,1.39,0,0,1,1.24,0,3.12,3.12,0,0,0-.11.67,2.11,2.11,0,0,0,3,2.13l.43-.14A3.85,3.85,0,0,0,287.07,105.62Zm-8.54,3.48a3.42,3.42,0,0,1-2.28,2.6l-.26.09a1.82,1.82,0,0,1-2.48-1.08,3.16,3.16,0,0,1,2.15-3.5l.43-.14A1.78,1.78,0,0,1,278.53,109.1Zm8.07-2.6a3.41,3.41,0,0,1-2.28,2.6l-.26.09a1.8,1.8,0,0,1-2.47-1.08,3.15,3.15,0,0,1,2.14-3.5l.43-.14A1.77,1.77,0,0,1,286.6,106.5Z",
    style: {
      fill: "#28A745"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.57,120.66c-2,.25-6.12,0-6.77-1.7a3.58,3.58,0,0,0,1.45,2c1.24.88,5.36,1.14,5.36,1.14Z",
    style: {
      fill: "#9a4a4d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.33,168.38c-3.39,0-5.55-3.41-4.65-7.55,0-.16.07-.29.1-.4.67-2,2.1-2.17,2.1-2.17h0c-1.34-.66-2-2.25-2.29-4L265,146.22a12.16,12.16,0,0,1,.31-4.27l-4.15-4.44-.77.82a13.46,13.46,0,0,0,.17,7.39l4.12,12.66A78.63,78.63,0,0,0,260.55,170c7.62,2.87,16.64-.16,22.1-4.23A28.25,28.25,0,0,1,271.33,168.38Z",
    style: {
      opacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M250,166.66c4.6-22.93,7.5-32.82,12.54-36.31a16.56,16.56,0,0,1,3.41-1.69c.69.26.76,1.78.9,2.75a24.21,24.21,0,0,1-2.62,13.13s-6.71,18.14-7.78,24.24c-.94,5.33-2,12-1.94,16.38a2.74,2.74,0,0,0,.74,1.93c1.23,1.21,1.23,2.44,2,3.93.62,1.16,1.3,1.47,1.11,1.83a1.59,1.59,0,0,1-2,.71,5.59,5.59,0,0,1-1.52-1.29,16.16,16.16,0,0,0,1.21,4.38c1.37,3.22,1,5.14-3.15,5-2.63-.09-4.28-2.18-4.67-9.36a64.22,64.22,0,0,1-.07-8.05C248.7,177.16,249.1,171,250,166.66Z",
    style: {
      fill: "#b16668"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.32,128.43a7.81,7.81,0,0,0-6.68,3.69,41.83,41.83,0,0,0-3.52,8.37c.81,1.69,5.3,6.11,7.48,6.66a32.49,32.49,0,0,0,1.92-4.49C266.84,138.93,268.9,132.55,266.32,128.43Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M296.3,142l-.06-2.93-3.48-2h0a1.11,1.11,0,0,0-1.11.11l-48.49,28a3.49,3.49,0,0,0-1.57,2.73v14.44a1.1,1.1,0,0,0,.45,1h0l3.49,2v-3.46l46.11-26.58a3.45,3.45,0,0,0,1.57-2.72V142Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.24,139.08l-3.48-2h0a1.11,1.11,0,0,0-1.11.11l-48.49,28a3.05,3.05,0,0,0-1,1L247.1,169l46.12-26Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.64,167.18l48.48-28c.87-.5,1.57-.09,1.57.91v14.49a3.47,3.47,0,0,1-1.57,2.73l-48.48,27.94c-.87.5-1.57.09-1.57-.91V169.91A3.47,3.47,0,0,1,246.64,167.18Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--stars--inject-15--inject-140"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M251.25,168.53l.89,1.88a.21.21,0,0,0,.28.11l2-.76c.31-.12.43.32.21.75l-1.43,2.68a.89.89,0,0,0-.11.51l.34,2.43c.05.38-.28.89-.56.85l-1.76-.22a.46.46,0,0,0-.36.21L249,179.23c-.28.35-.61.23-.56-.22l.34-2.82a.4.4,0,0,0-.11-.38l-1.43-1c-.22-.17-.1-.75.22-1l2-1.53a.94.94,0,0,0,.29-.44l.88-2.89C250.71,168.47,251.11,168.23,251.25,168.53Z",
    style: {
      fill: "#28A745"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.24,162.82l.88,1.87a.21.21,0,0,0,.29.11l2-.75c.31-.12.44.32.21.74l-1.43,2.68a.89.89,0,0,0-.11.51l.34,2.43c.05.38-.27.89-.55.86l-1.77-.22a.41.41,0,0,0-.35.2L259,173.51c-.28.36-.6.23-.55-.22l.34-2.81a.42.42,0,0,0-.11-.39l-1.43-1c-.23-.16-.1-.75.21-1l2-1.52a.91.91,0,0,0,.29-.45l.88-2.89C260.69,162.75,261.1,162.52,261.24,162.82Z",
    style: {
      fill: "#28A745"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.22,157.1l.88,1.87a.22.22,0,0,0,.29.12l2-.76c.32-.12.44.32.22.75l-1.43,2.67a.93.93,0,0,0-.11.52l.34,2.42c.05.39-.28.89-.56.86l-1.76-.22a.44.44,0,0,0-.36.21l-1.76,2.25c-.28.36-.61.23-.56-.21l.34-2.82a.42.42,0,0,0-.11-.39l-1.43-1c-.22-.16-.1-.75.22-1l2-1.52a.94.94,0,0,0,.29-.44l.88-2.9C270.68,157,271.08,156.8,271.22,157.1Z",
    style: {
      fill: "#28A745"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.21,151.38l.88,1.88a.21.21,0,0,0,.29.11l2-.76c.31-.12.44.32.21.75L283.13,156a.89.89,0,0,0-.11.51l.34,2.43c.05.38-.27.89-.55.85l-1.77-.21a.41.41,0,0,0-.35.2l-1.77,2.26c-.28.35-.61.23-.55-.22l.33-2.81a.39.39,0,0,0-.11-.39l-1.42-1c-.23-.17-.1-.75.21-1l2-1.53a.88.88,0,0,0,.29-.44l.88-2.89C280.66,151.32,281.07,151.09,281.21,151.38Z",
    style: {
      fill: "#28A745"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.19,145.67l.88,1.87a.21.21,0,0,0,.29.11l2-.75c.32-.12.44.32.21.74l-1.42,2.68a.91.91,0,0,0-.11.52l.33,2.42c.06.39-.27.89-.55.86L291,153.9a.44.44,0,0,0-.36.2l-1.76,2.26c-.28.36-.61.23-.56-.22l.34-2.81a.42.42,0,0,0-.11-.39l-1.43-1c-.22-.16-.1-.75.21-1l2-1.52a.89.89,0,0,0,.28-.45l.89-2.89C290.65,145.6,291.05,145.37,291.19,145.67Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M230.61,211.87l-.06-2.93-3.48-2h0a1.09,1.09,0,0,0-1.11.11l-48.48,28a3.46,3.46,0,0,0-1.57,2.72v61.66a1.13,1.13,0,0,0,.44,1h0l3.48,2V299L226,272.41a3.48,3.48,0,0,0,1.58-2.72V211.87Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.55,208.94l-3.48-2h0a1.09,1.09,0,0,0-1.11.11l-48.48,28a3.12,3.12,0,0,0-1,1l4.92,2.85,46.13-26.05Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181,237l48.49-28c.87-.5,1.57-.1,1.57.91v61.71a3.46,3.46,0,0,1-1.57,2.72L181,302.33c-.87.5-1.58.1-1.58-.91V239.76A3.49,3.49,0,0,1,181,237Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-3--inject-15--inject-140)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M219.53,298.91c-5.84-25.63-12.87-30.28-6.63-35.62,7.27-1.11,10.08,1.17,11.2,8.69.55,3.67,1.74,19,3.23,24.78,1.31,5.05,3.08,11.3,5,14.91A2.14,2.14,0,0,0,234,312.8c1.83.26,2.36,1.29,3.85,2,1.17.6,2,.45,2,.86a2.27,2.27,0,0,1-1.84,1.81,6.23,6.23,0,0,1-2.18-.14,12,12,0,0,0,3.18,2.92c2.86,1.85,3.34,3.66-1.2,6.08-2.85,1.51-5.51.77-9-5a47.07,47.07,0,0,1-3.55-6.68C222.72,308.45,220.47,303,219.53,298.91Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.9,263.29s3.76-1.13,6.53,0,5,2.72,5.73,13.57l-5.63,3.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.66,266.31h0a9.23,9.23,0,0,0,9.23-9.23V244.29h0a9.24,9.24,0,0,0-9.23,9.23Z",
    style: {
      fill: "#28A745"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.66,266.31h0a9.23,9.23,0,0,0,9.23-9.23V244.29h0a9.24,9.24,0,0,0-9.23,9.23Z",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.08,259.43a11.81,11.81,0,0,1-15.22-11.31h0c0-8.4,5.9-16.79,13.18-18.74l1-.26c7.28-2,13.17,3.28,13.17,11.68v2.34a17,17,0,0,1-12.11,16.29Z",
    style: {
      fill: "#28A745"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.08,259.43a11.81,11.81,0,0,1-15.22-11.31h0c0-8.4,5.9-16.79,13.18-18.74l1-.26c7.28-2,13.17,3.28,13.17,11.68v2.34a17,17,0,0,1-12.11,16.29Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.39,232.86c-.71-.71-1.92-.44-2.7.59l1.44,1.43a1.81,1.81,0,0,0-1,.19,3,3,0,0,0-1.48,3l3.75-1.91a1.6,1.6,0,0,0-.08-.26A2.46,2.46,0,0,0,200.39,232.86Z",
    style: {
      fill: "#28A745"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.39,232.86c-.71-.71-1.92-.44-2.7.59l1.44,1.43a1.81,1.81,0,0,0-1,.19,3,3,0,0,0-1.48,3l3.75-1.91a1.6,1.6,0,0,0-.08-.26A2.46,2.46,0,0,0,200.39,232.86Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.15,265.92s-8,1.89-8.93,2.64c5.77,6.2,1.05,19.27,1.05,19.27L199.48,299a64.64,64.64,0,0,0-6.59,15.06c-1.91,6.34-3.13,11.11-4.61,30.2,7.58,6,32.83-.56,39.25-12,0,0-2-12.52-4.52-24.15-1.87-8.49-3.71-13.08-3.26-16.14,3.39-12.93,3.65-16.15,3.05-18.67-1.69-7.1-8.35-10.42-10-10Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.05,233.79c1.44.6,3.23,4.31,3,13.15-.15,7.49-2.24,9.89-3.29,10.7s-3.07,1-5,1.18v4.47s2.72,2.92,2.55,5-3.93,3.59-6.48,2.27-4.69-4.65-4.69-4.65l0-10.29s-1.16,1.61-3.12.15a4.23,4.23,0,0,1-.91-5.63c1.26-1.82,3.6-2.05,4.5-.17a13.35,13.35,0,0,1,5.62-6.73C214.39,240.61,216.62,238.23,218.05,233.79Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.9,247a1.27,1.27,0,0,1-.77,1.22c-.45.14-.83-.17-.85-.7a1.26,1.26,0,0,1,.77-1.22C213.49,246.15,213.88,246.47,213.9,247Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.12,253.25l1.88.19a1.33,1.33,0,0,1-1.23,1.11C214.25,254.5,214,253.92,214.12,253.25Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.55,242.34l-1.64-.88c.3-.62.91-.92,1.36-.68A1.18,1.18,0,0,1,220.55,242.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.54,245.45l1.64-1.76c-.3-.46-.91-.44-1.36.05A1.48,1.48,0,0,0,211.54,245.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.17,244.64a1.26,1.26,0,0,1-.77,1.22c-.44.14-.83-.17-.85-.7a1.26,1.26,0,0,1,.77-1.22C219.77,243.8,220.15,244.11,220.17,244.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "216.34 245.13 216.47 250.73 219.04 249.12 216.34 245.13",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.77,258.82c-2.08.24-6.34,0-7-1.8a3.68,3.68,0,0,0,1.5,2.08c1.27.92,5.51,1.21,5.51,1.21Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.46,308.61c4.94-24.64,8.35-36.27,13.76-40.05,2.71.28,3.53,3.88,3.81,5.94a23.35,23.35,0,0,1-2.76,13.33s-6.73,16.5-7.88,23.05c-1,5.73-2.15,12.9-2.09,17.6a2.94,2.94,0,0,0,.8,2.07c1.32,1.3,1.33,2.63,2.18,4.22.67,1.25,1.4,1.59,1.19,2a1.7,1.7,0,0,1-2.16.76,5.64,5.64,0,0,1-1.64-1.38,17.67,17.67,0,0,0,1.3,4.71c1.48,3.45,1.12,5.51-3.39,5.35-2.82-.11-4.59-2.35-5-10.06a69.84,69.84,0,0,1-.08-8.65C180.09,319.88,180.53,313.24,181.46,308.61Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.12,268.18c-2.21.77-4.36,2.95-6.41,7.69s-4.48,14.57-4.48,14.57,4.34,4.58,9.13,3.21c0,0,3.72-7.74,4.66-11.79S200.69,270.52,196.12,268.18Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M230.61,285.12l-.06-2.93-3.48-2h0a1.09,1.09,0,0,0-1.11.11l-48.48,28a3.46,3.46,0,0,0-1.57,2.72v14.44a1.13,1.13,0,0,0,.44,1h0l3.48,2V325L226,298.44a3.48,3.48,0,0,0,1.58-2.72v-10.6Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.55,282.19l-3.48-2h0a1.09,1.09,0,0,0-1.11.11l-48.48,28a3.12,3.12,0,0,0-1,1l4.92,2.85,46.13-26Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181,310.29l48.49-28c.87-.5,1.57-.1,1.57.91V297.7a3.46,3.46,0,0,1-1.57,2.72L181,328.36c-.87.51-1.58.1-1.58-.9V313A3.49,3.49,0,0,1,181,310.29Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--stars--inject-15--inject-140"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M185.57,311.64l.88,1.87a.22.22,0,0,0,.29.12l2-.76c.31-.12.44.32.21.75l-1.42,2.67a.85.85,0,0,0-.11.52l.33,2.42c.06.39-.27.9-.55.86l-1.77-.22a.45.45,0,0,0-.35.21l-1.76,2.25c-.29.36-.61.23-.56-.21l.34-2.82a.42.42,0,0,0-.11-.39l-1.43-1c-.23-.16-.1-.75.21-1l2-1.52a.82.82,0,0,0,.29-.44l.88-2.89C185,311.58,185.43,311.34,185.57,311.64Z",
    style: {
      fill: "#28A745"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.55,305.92l.89,1.88a.2.2,0,0,0,.28.11l2-.76c.31-.12.43.32.21.75l-1.43,2.68a.89.89,0,0,0-.11.51l.34,2.43c0,.38-.28.89-.56.85l-1.76-.21a.42.42,0,0,0-.36.2l-1.76,2.26c-.28.35-.61.23-.55-.22l.33-2.81a.41.41,0,0,0-.11-.39l-1.42-1c-.23-.17-.11-.75.21-1l2-1.52a1,1,0,0,0,.29-.45l.88-2.89C195,305.86,195.41,305.63,195.55,305.92Z",
    style: {
      fill: "#28A745"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.54,300.21l.88,1.87a.21.21,0,0,0,.29.11l2-.75c.31-.12.44.32.21.74l-1.43,2.68a.91.91,0,0,0-.11.52l.34,2.42c.06.39-.27.89-.55.86l-1.77-.22a.43.43,0,0,0-.35.2l-1.77,2.26c-.28.36-.6.23-.55-.22l.34-2.81a.42.42,0,0,0-.11-.39l-1.43-1c-.23-.16-.1-.75.21-1l2-1.52a.84.84,0,0,0,.29-.45l.88-2.89C205,300.14,205.4,299.91,205.54,300.21Z",
    style: {
      fill: "#28A745"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.52,294.49l.88,1.87a.22.22,0,0,0,.29.12l2-.76c.32-.12.44.32.22.75l-1.43,2.68a.88.88,0,0,0-.11.51l.34,2.42c0,.39-.28.9-.56.86l-1.76-.22a.46.46,0,0,0-.36.21l-1.76,2.25c-.28.36-.61.23-.56-.21l.34-2.82a.4.4,0,0,0-.11-.38l-1.43-1c-.22-.16-.1-.75.22-1l2-1.52a.94.94,0,0,0,.29-.44l.88-2.89C215,294.43,215.38,294.19,215.52,294.49Z",
    style: {
      fill: "#28A745"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.36,302.72l1.76.22c.28,0,.61-.47.56-.86l-.34-2.42a.88.88,0,0,1,.11-.51l1.43-2.68c.22-.43.1-.87-.22-.75l-2,.76a.22.22,0,0,1-.29-.12l-.88-1.87c-.07-.15-.2-.16-.34-.09v8.37A.31.31,0,0,1,215.36,302.72Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.51,288.77l.88,1.88a.21.21,0,0,0,.29.11l2-.76c.31-.12.44.32.21.75l-1.43,2.68a.89.89,0,0,0-.11.51l.34,2.43c.05.38-.27.89-.55.85l-1.77-.21a.41.41,0,0,0-.35.2l-1.77,2.26c-.28.35-.61.23-.55-.22l.34-2.81a.41.41,0,0,0-.11-.39l-1.43-1c-.23-.17-.1-.75.21-1l2-1.52a1,1,0,0,0,.29-.45l.88-2.89C225,288.71,225.37,288.48,225.51,288.77Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M230.61,106.64l-.06-2.93-3.48-2h0a1.11,1.11,0,0,0-1.11.11l-48.48,28a3.47,3.47,0,0,0-1.57,2.73v61.66a1.11,1.11,0,0,0,.44,1h0l3.48,2v-3.46L226,167.18a3.46,3.46,0,0,0,1.58-2.72V106.64Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.55,103.71l-3.48-2h0a1.11,1.11,0,0,0-1.11.11l-48.48,28a3.05,3.05,0,0,0-1,1l4.92,2.84,46.13-26Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181,131.81l48.49-28c.87-.5,1.57-.09,1.57.91v61.71a3.47,3.47,0,0,1-1.57,2.73L181,197.11c-.87.5-1.58.09-1.58-.91V134.54A3.51,3.51,0,0,1,181,131.81Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-4--inject-15--inject-140)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-boy--inject-15--inject-140"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M214.83,157.89s3.81-1.18,7,3.83c2.15,3.4,9.69,16.33,9.69,16.33s14.67-7.78,15.5-8.8.77-3.08.9-4.19a12.36,12.36,0,0,0-.57-4.12c-.17-1.17,1.5-1.23,2.33.38.61,1.19.66,2.54,1.18,2.55a14.57,14.57,0,0,0,2.06-1.75c.91-1,2.55-2.66,3.79-2.43a1.08,1.08,0,0,1,.83.89,6,6,0,0,0,.47,2,3.18,3.18,0,0,1,.49.79,7,7,0,0,1,0,1.29c0,.61.64.87.73,1.47a11.17,11.17,0,0,1-.16,1.39c0,.3.1.56.1.85a2.83,2.83,0,0,1-.76,1.63,17.22,17.22,0,0,1-4.35,3.65c-1.34.87-3.1,1.65-4.62,2.47s-18.8,14.09-21.1,12.52-13.84-18.38-13.84-18.38C211.84,162.83,214.83,157.89,214.83,157.89Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.14,158s4.2-1.7,6.92-1.53,4.75,1,6.74,4.17c2.67,4.29,7.09,11.69,7.09,11.69a21.4,21.4,0,0,1-8.58,9.18l-8.14-12.27Z",
    style: {
      fill: "#28A745"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.25
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M208.14,158s4.2-1.7,6.92-1.53,4.75,1,6.74,4.17c2.67,4.29,7.09,11.69,7.09,11.69a21.4,21.4,0,0,1-8.58,9.18l-8.14-12.27Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-boy--inject-15--inject-140"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M194.81,165.42a9.16,9.16,0,0,0-3,4.37,21.59,21.59,0,0,0-.9,6.4v13.95l-.18,26.39c8.85,3,20.11.36,29.55-10.13,0,0-.53-33.77-.53-39.32,0-.25,0-.5,0-.75-.34-7.83-7.09-11.46-13.75-7.7l-5.58,3.15-5.62,3.64Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.87,136.72c0,5.95,4.18,9.65,9.33,8.27s9.33-7.32,9.33-13.27-4.44-6-9.6-4.58S200.87,130.77,200.87,136.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196,146.13s1.38,7.09,1.93,8.17a2.1,2.1,0,0,0,1.69,1.12l-.1-5.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.73,135a3.84,3.84,0,0,0-2.64,1.77c-1.13,1.64-.5,5.66.91,9.37l2.59-.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.37,145.58c-.52.5-1.26-.46-1.9-1.06s-2.73-1.1-3.78,1.72.92,5.75,2.57,5.91c2.84.27,3.26-2,3.26-2l.1,12.11c4.76,5,13.09-.9,9.35-3.14v-3.59a16.31,16.31,0,0,0,3.82-.8c2.09-.93,3.4-3.18,4-6,1-4.46,1.4-7.94.54-15.95-.94-8.77-10-6.43-14.94-1.54S199.37,145.58,199.37,145.58Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.37,146.59c-.26.07-1.26-1.56-1.9-2.07-.9-.7.26-9.53.26-9.53-1-2.28.87-5.72,2.87-7.12a11.58,11.58,0,0,1,4.73-1.73c1.43-.27,2.86-.47,4.28-.6a38.84,38.84,0,0,0,5.19-.62,11.59,11.59,0,0,0,4.1-1.76c.42-.29.84,0,.71.55a8,8,0,0,1-.49,1.36,12.92,12.92,0,0,1-1.38,2.43,20.33,20.33,0,0,1-2,2.22c-3.84,3.64-8.69,4.63-13,5.1-1,.1-1.17,1.24-1.69,4.32C200.62,141.85,200.25,146.33,199.37,146.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.73,135.65l-3.14-1.11c.45-1.15,1.51-1.85,2.38-1.54S198.18,134.49,197.73,135.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209,155.58s-4.66.16-6.29-.4a4,4,0,0,1-2.25-2,6.93,6.93,0,0,0,1.28,2.69C202.89,157.34,209,157,209,157Z",
    style: {
      fill: "#f29077"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.84,142a1.45,1.45,0,0,1-.93,1.37c-.52.14-.94-.25-.94-.87a1.44,1.44,0,0,1,.94-1.37C207.42,141,207.84,141.35,207.84,142Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.34,137.9l-2,1.81a1.77,1.77,0,0,1,.47-2A.92.92,0,0,1,206.34,137.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.54,149.22l2.13.35a1.46,1.46,0,0,1-1.45,1.2C208.63,150.68,208.33,150,208.54,149.22Z",
    style: {
      fill: "#f29077"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.4,136.16,214.58,135c.37-.7,1.08-1,1.58-.71A1.42,1.42,0,0,1,216.4,136.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.6,139.58a1.42,1.42,0,0,1-.93,1.36c-.52.14-.94-.25-.94-.87a1.42,1.42,0,0,1,.94-1.36C215.18,138.57,215.6,139,215.6,139.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "210.99 139.95 211.1 146.45 214.44 144.71 210.99 139.95",
    style: {
      fill: "#f29077"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M181.65,205.33c2-26.89,5.94-36.53,12.49-39.36,2.26,1.69,2.81,9.59.44,15.6,0,0-5.08,17.92-5.37,24a97.31,97.31,0,0,0,1,17,2.41,2.41,0,0,0,1,1.68c1.43.93,1.34,2.29,2.36,3.57.81,1,1.55,1.18,1.4,1.55a1.79,1.79,0,0,1-2,1.07,5.23,5.23,0,0,1-1.76-.95,14.43,14.43,0,0,0,1.85,4c1.86,2.85,1.77,4.77-2.6,5.41-2.74.41-4.74-1.29-6.12-8.16-.39-2-1.33-5.54-1.72-8.1A79.11,79.11,0,0,1,181.65,205.33Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196,164.65s-4.77,1.67-7.18,5.58-4.71,10.2-6.32,21.36c0,0,3,4.12,10.89.69,0,0,3.43-14.24,3.74-19.87C197.46,166.27,196,164.65,196,164.65Z",
    style: {
      fill: "#28A745"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196,164.65s-4.77,1.67-7.18,5.58-4.71,10.2-6.32,21.36c0,0,3,4.12,10.89.69,0,0,3.43-14.24,3.74-19.87C197.46,166.27,196,164.65,196,164.65Z",
    style: {
      opacity: 0.15
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M230.61,179.89l-.06-2.93-3.48-2h0a1.11,1.11,0,0,0-1.11.11l-48.48,28a3.47,3.47,0,0,0-1.57,2.73v14.44a1.11,1.11,0,0,0,.44,1h0l3.48,2v-3.46L226,193.22a3.49,3.49,0,0,0,1.58-2.73v-10.6Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.55,177l-3.48-2h0a1.11,1.11,0,0,0-1.11.11l-48.48,28a3.05,3.05,0,0,0-1,1l4.92,2.84,46.13-26Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181,205.06l48.49-28c.87-.5,1.57-.09,1.57.91v14.49a3.47,3.47,0,0,1-1.57,2.73L181,223.14c-.87.5-1.58.09-1.58-.91V207.79A3.51,3.51,0,0,1,181,205.06Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--stars--inject-15--inject-140"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M185.57,206.41l.88,1.88a.22.22,0,0,0,.29.11l2-.76c.31-.12.44.32.21.75l-1.42,2.68a.82.82,0,0,0-.11.51l.33,2.43c.06.38-.27.89-.55.85l-1.77-.21a.41.41,0,0,0-.35.2l-1.76,2.26c-.29.35-.61.23-.56-.22l.34-2.81a.41.41,0,0,0-.11-.39l-1.43-1c-.23-.17-.1-.75.21-1l2-1.52a.88.88,0,0,0,.29-.45l.88-2.89C185,206.35,185.43,206.12,185.57,206.41Z",
    style: {
      fill: "#28A745"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.55,200.7l.89,1.87a.2.2,0,0,0,.28.11l2-.75c.31-.12.43.32.21.74l-1.43,2.68a.91.91,0,0,0-.11.52l.34,2.42c0,.39-.28.89-.56.86l-1.76-.22a.45.45,0,0,0-.36.2l-1.76,2.26c-.28.36-.61.23-.55-.22l.33-2.81a.42.42,0,0,0-.11-.39l-1.42-1c-.23-.16-.11-.75.21-1l2-1.52A1,1,0,0,0,194,204l.88-2.89C195,200.63,195.41,200.4,195.55,200.7Z",
    style: {
      fill: "#28A745"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.54,195l.88,1.87a.22.22,0,0,0,.29.12l2-.76c.31-.12.44.32.21.75l-1.43,2.68a.88.88,0,0,0-.11.51l.34,2.42c.06.39-.27.9-.55.86l-1.77-.22a.45.45,0,0,0-.35.21l-1.77,2.25c-.28.36-.6.23-.55-.21l.34-2.82a.4.4,0,0,0-.11-.38l-1.43-1c-.23-.16-.1-.75.21-1l2-1.52a.82.82,0,0,0,.29-.44l.88-2.89C205,194.92,205.4,194.68,205.54,195Z",
    style: {
      fill: "#28A745"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.52,189.26l.88,1.88a.21.21,0,0,0,.29.11l2-.76c.32-.12.44.32.22.75l-1.43,2.68a.89.89,0,0,0-.11.51l.34,2.43c0,.38-.28.89-.56.85l-1.76-.21a.42.42,0,0,0-.36.2L213.24,200c-.28.35-.61.23-.56-.22l.34-2.81a.41.41,0,0,0-.11-.39l-1.43-1c-.22-.17-.1-.75.22-1l2-1.52a1,1,0,0,0,.29-.45l.88-2.89C215,189.2,215.38,189,215.52,189.26Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.51,183.55l.88,1.87a.21.21,0,0,0,.29.11l2-.75c.31-.12.44.32.21.74l-1.43,2.68a.91.91,0,0,0-.11.52l.34,2.42c.05.39-.27.89-.55.86l-1.77-.22a.43.43,0,0,0-.35.2l-1.77,2.26c-.28.36-.61.23-.55-.22l.34-2.81a.42.42,0,0,0-.11-.39l-1.43-1c-.23-.16-.1-.75.21-1l2-1.52a.91.91,0,0,0,.29-.45l.88-2.89C225,183.48,225.37,183.25,225.51,183.55Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M164.87,249.82l-.06-2.92-3.48-2h0a1.11,1.11,0,0,0-1.11.11l-48.48,28a3.48,3.48,0,0,0-1.58,2.72V337.4a1.11,1.11,0,0,0,.45,1h0l3.48,2v-3.47l46.11-26.57a3.46,3.46,0,0,0,1.57-2.72V249.82Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.81,246.9l-3.48-2h0a1.11,1.11,0,0,0-1.11.11l-48.48,28a3.14,3.14,0,0,0-1,1l4.93,2.85,46.12-26.05Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.21,275l48.48-28c.87-.5,1.58-.1,1.58.9v61.72a3.48,3.48,0,0,1-1.58,2.72l-48.48,27.94c-.87.5-1.57.1-1.57-.91V277.72A3.46,3.46,0,0,1,115.21,275Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-5--inject-15--inject-140)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M149.09,301.07s3.81-1.17,7,3.83c2.16,3.41,9.7,16.33,9.7,16.33s14.67-7.78,15.49-8.79.78-3.09.9-4.2a11.89,11.89,0,0,0-.57-4.12c-.17-1.17,1.51-1.23,2.34.39.61,1.18.65,2.53,1.18,2.55a15.36,15.36,0,0,0,2-1.76c.91-1,2.56-2.66,3.8-2.43a1.11,1.11,0,0,1,.83.9,5.53,5.53,0,0,0,.47,2,3.36,3.36,0,0,1,.49.8,7.83,7.83,0,0,1,0,1.28c.05.62.65.88.73,1.48a9.82,9.82,0,0,1-.15,1.39c0,.29.09.55.09.85a2.84,2.84,0,0,1-.75,1.63,17.43,17.43,0,0,1-4.36,3.64c-1.33.88-3.1,1.65-4.61,2.48s-18.8,14.08-21.1,12.51-13.84-18.37-13.84-18.37C146.1,306,149.09,301.07,149.09,301.07Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.4,301.19s4.2-1.71,6.92-1.53,4.74.95,6.74,4.16c2.67,4.29,7.08,11.7,7.08,11.7a21.32,21.32,0,0,1-8.58,9.18l-8.13-12.28Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.07,308.61a8.94,8.94,0,0,0-3,4.36,21.31,21.31,0,0,0-.9,6.4v13.95L125,359.71c8.85,3,20.1.36,29.54-10.13,0,0-.52-33.77-.52-39.31,0-.25,0-.51,0-.76-.34-7.83-7.1-11.46-13.75-7.7L134.68,305l-5.61,3.64Z",
    style: {
      fill: "#28A745"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.07,308.61a8.94,8.94,0,0,0-3,4.36,21.31,21.31,0,0,0-.9,6.4v13.95L125,359.71c8.85,3,20.1.36,29.54-10.13,0,0-.52-33.77-.52-39.31,0-.25,0-.51,0-.76-.34-7.83-7.1-11.46-13.75-7.7L134.68,305l-5.61,3.64Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.13,279.9c0,6,4.18,9.66,9.33,8.28s9.33-7.33,9.33-13.28-4.45-5.95-9.6-4.57S135.13,274,135.13,279.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.26,289.32s1.37,7.09,1.92,8.17a2.14,2.14,0,0,0,1.69,1.12l-.09-5.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132,278.17a3.85,3.85,0,0,0-2.63,1.78c-1.13,1.64-.5,5.65.91,9.37l2.59-.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.62,288.76c-.52.5-1.26-.45-1.9-1.06s-2.73-1.09-3.77,1.72.92,5.76,2.57,5.91c2.83.27,3.26-1.94,3.26-1.94l.09,12.1c4.76,5.05,13.1-.9,9.35-3.13v-3.6A16.25,16.25,0,0,0,147,298c2.08-.94,3.4-3.19,4-6,1-4.46,1.4-7.95.54-15.95-1-8.78-10-6.43-15-1.55S133.62,288.76,133.62,288.76Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.62,289.77c-.26.08-1.25-1.56-1.9-2.07-.33-.26-.3-1-.32-1.39a37.47,37.47,0,0,1,.29-5.6,11.35,11.35,0,0,0,.1-3.39,7.86,7.86,0,0,1,.15-3.67A6.48,6.48,0,0,1,134.5,270a6.6,6.6,0,0,1,5.44-.77,2.69,2.69,0,0,1,1.31-2.18,4.11,4.11,0,0,1,2.55-.54A2.41,2.41,0,0,1,146,268a4.45,4.45,0,0,1,3.34-2.67,4.35,4.35,0,0,1,3.72,1.16c.82.91,1,2.62.93,3.79a6.39,6.39,0,0,1-.22,1.62,4.81,4.81,0,0,1-2.21,2.78,5.45,5.45,0,0,1-3.52.65c.26,0-.49,1.9-.59,2.06a3.35,3.35,0,0,1-1.73,1.46,3.89,3.89,0,0,1-4.05-1.05,2.05,2.05,0,0,1-2,1.47,16.94,16.94,0,0,1-2.64-.3c-1.69-.16-1.53,2.23-1.72,3.4C134.88,285,134.5,289.52,133.62,289.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132,278.83l-3.14-1.1a2.1,2.1,0,0,1,2.38-1.55A2,2,0,0,1,132,278.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.21,298.76s-4.65.17-6.28-.4a4,4,0,0,1-2.25-2,7,7,0,0,0,1.28,2.69c1.19,1.43,7.25,1.1,7.25,1.1Z",
    style: {
      fill: "#f29077"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.1,285.58a1.42,1.42,0,0,1-.94,1.36c-.51.14-.93-.25-.93-.87a1.42,1.42,0,0,1,.93-1.36C141.68,284.57,142.1,285,142.1,285.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.6,281.52l-2,1.81a1.75,1.75,0,0,1,.47-2A.92.92,0,0,1,140.6,281.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.79,292.4l2.13.36a1.46,1.46,0,0,1-1.44,1.2C142.89,293.86,142.58,293.17,142.79,292.4Z",
    style: {
      fill: "#f29077"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.65,279.77l-1.82-1.13c.38-.7,1.08-1,1.59-.7A1.39,1.39,0,0,1,150.65,279.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.26,283.08a1.44,1.44,0,0,1-.94,1.37c-.51.13-.93-.26-.93-.88a1.43,1.43,0,0,1,.93-1.36C149.84,282.07,150.26,282.46,150.26,283.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "145.24 283.13 145.35 289.64 148.7 287.89 145.24 283.13",
    style: {
      fill: "#f29077"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.91,348.51c2-26.88,5.94-36.52,12.49-39.35,2.26,1.68,2.8,9.59.44,15.59,0,0-5.09,17.93-5.38,24a98.24,98.24,0,0,0,1,17,2.4,2.4,0,0,0,1,1.68c1.44.93,1.35,2.29,2.37,3.57.8,1,1.55,1.18,1.4,1.56a1.79,1.79,0,0,1-2,1.07,5.53,5.53,0,0,1-1.76-1,14.8,14.8,0,0,0,1.85,4c1.87,2.84,1.78,4.76-2.6,5.41-2.74.4-4.73-1.3-6.11-8.16-.4-2-1.33-5.54-1.72-8.11A78.49,78.49,0,0,1,115.91,348.51Z",
    style: {
      fill: "#ffbda7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.26,307.84s-4.77,1.67-7.18,5.57-4.71,10.2-6.32,21.36c0,0,3,4.13,10.89.7,0,0,3.43-14.25,3.73-19.87C131.72,309.46,130.26,307.84,130.26,307.84Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138,286.51a4.48,4.48,0,0,1,3.06-3.76l.15-.05c1.6-.51,3.11.18,3.34,1.71a4.2,4.2,0,0,1-2.86,4.26l-.48.15A2.29,2.29,0,0,1,138,286.51Zm2.92-3.2a3.43,3.43,0,0,0-2.33,3.8,2,2,0,0,0,2.69,1.18l.28-.09a3.72,3.72,0,0,0,2.48-2.83,1.93,1.93,0,0,0-2.65-2.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.8,283.69a4.47,4.47,0,0,1,3.06-3.76l.15-.05c1.6-.51,3.11.18,3.34,1.71a4.2,4.2,0,0,1-2.86,4.26L150,286A2.29,2.29,0,0,1,146.8,283.69Zm2.92-3.2a3.43,3.43,0,0,0-2.33,3.8,2,2,0,0,0,2.69,1.17l.28-.09a3.69,3.69,0,0,0,2.48-2.82,1.93,1.93,0,0,0-2.65-2.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.26,283.86a3.06,3.06,0,0,1,1.31-.92A1.42,1.42,0,0,1,147,283l.39-.44a1.79,1.79,0,0,0-1.88-.13,3.74,3.74,0,0,0-1.61,1.13C143.77,283.75,144.15,284,144.26,283.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.44,288.47l5.87-1.88,0-.51-6.17,2A2.2,2.2,0,0,1,132.44,288.47Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M164.87,323.57l-.06-2.92-3.48-2h0a1.12,1.12,0,0,0-1.11.12l-48.48,28a3.48,3.48,0,0,0-1.58,2.72v14.44a1.11,1.11,0,0,0,.45,1h0l3.48,2v-3.47l46.11-26.57a3.46,3.46,0,0,0,1.57-2.72V323.57Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.81,320.65l-3.48-2h0a1.12,1.12,0,0,0-1.11.12l-48.48,28a3.14,3.14,0,0,0-1,1l4.93,2.85,46.12-26.05Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.21,348.75l48.48-28c.87-.5,1.58-.1,1.58.91v14.49a3.48,3.48,0,0,1-1.58,2.72l-48.48,27.94c-.87.5-1.57.1-1.57-.91V351.47A3.46,3.46,0,0,1,115.21,348.75Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--stars--inject-15--inject-140"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.83,350.1l.88,1.87a.21.21,0,0,0,.29.11l2-.75c.31-.12.44.32.21.74l-1.43,2.68a.91.91,0,0,0-.11.52l.34,2.42c0,.39-.27.89-.55.86l-1.77-.22a.42.42,0,0,0-.35.21l-1.77,2.25c-.28.36-.61.23-.55-.22l.33-2.81a.4.4,0,0,0-.11-.39l-1.42-1c-.23-.16-.1-.75.21-1l2-1.52a.92.92,0,0,0,.29-.44l.88-2.9C119.28,350,119.69,349.8,119.83,350.1Z",
    style: {
      fill: "#28A745"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.81,344.38l.88,1.87a.22.22,0,0,0,.29.12l2-.76c.32-.12.44.32.21.75L131.74,349a.89.89,0,0,0-.11.51L132,352c.06.38-.27.89-.55.85l-1.76-.22a.45.45,0,0,0-.36.21l-1.76,2.25c-.28.36-.61.23-.56-.21l.34-2.82a.4.4,0,0,0-.11-.38l-1.43-1c-.23-.17-.1-.75.21-1l2-1.52a.86.86,0,0,0,.28-.44l.89-2.89C129.27,344.32,129.67,344.08,129.81,344.38Z",
    style: {
      fill: "#28A745"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.79,338.66l.89,1.88a.2.2,0,0,0,.28.11l2-.76c.31-.12.43.33.21.75l-1.43,2.68a.89.89,0,0,0-.11.51l.34,2.43c.05.38-.28.89-.56.86l-1.76-.22c-.11,0-.24.06-.36.2l-1.76,2.26c-.28.36-.61.23-.55-.22l.33-2.81a.41.41,0,0,0-.11-.39l-1.42-1c-.23-.16-.11-.75.21-1l2-1.52a1,1,0,0,0,.29-.45l.88-2.89C139.25,338.6,139.65,338.37,139.79,338.66Z",
    style: {
      fill: "#28A745"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.78,333l.88,1.87a.21.21,0,0,0,.29.11l2-.75c.31-.12.44.32.21.74l-1.42,2.68a.84.84,0,0,0-.11.52l.33,2.42c.06.39-.27.89-.55.86l-1.77-.22a.42.42,0,0,0-.35.21l-1.77,2.25c-.28.36-.6.23-.55-.22l.34-2.81a.42.42,0,0,0-.11-.39l-1.43-1c-.23-.16-.1-.75.21-1l2-1.52a.86.86,0,0,0,.29-.44l.88-2.9C149.23,332.88,149.64,332.65,149.78,333Z",
    style: {
      fill: "#28A745"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.76,327.23l.89,1.88a.21.21,0,0,0,.28.11l2-.76c.31-.12.43.32.21.75l-1.43,2.68a.89.89,0,0,0-.11.51l.34,2.43c.05.38-.28.89-.56.85l-1.76-.22a.46.46,0,0,0-.36.21l-1.76,2.25c-.28.36-.61.23-.56-.21l.34-2.82a.4.4,0,0,0-.11-.38l-1.43-1c-.22-.17-.1-.75.22-1l2-1.52a.94.94,0,0,0,.29-.44l.88-2.89C159.22,327.17,159.62,326.93,159.76,327.23Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M164.87,144.6l-.06-2.92-3.48-2h0a1.11,1.11,0,0,0-1.11.11l-48.48,28a3.48,3.48,0,0,0-1.58,2.72v61.66a1.11,1.11,0,0,0,.45,1h0l3.48,2v-3.46l46.11-26.57a3.46,3.46,0,0,0,1.57-2.72V144.6Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.81,141.68l-3.48-2h0a1.11,1.11,0,0,0-1.11.11l-48.48,28a3,3,0,0,0-1,1l4.93,2.85,46.12-26Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.21,169.78l48.48-28c.87-.51,1.58-.1,1.58.9v61.72a3.48,3.48,0,0,1-1.58,2.72l-48.48,27.94c-.87.5-1.57.09-1.57-.91V172.5A3.46,3.46,0,0,1,115.21,169.78Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-6--inject-15--inject-140)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155.24,206.33l-26.36,7.31s0-20,0-27h0c0-8.4,5.85-16.82,13.13-18.8h0c7.28-2,13.2,3.21,13.23,11.6h0C155.27,186.41,155.24,206.33,155.24,206.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.12,177.52l-3.41-2.44a2.29,2.29,0,0,1,2.89,0A1.63,1.63,0,0,1,131.12,177.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.37,176.87l-1.35-4a2.31,2.31,0,0,1,2.36,1.68A1.63,1.63,0,0,1,131.37,176.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.81,233.41c-5.44-23.86-11.67-28.07-5.85-33,6-2.28,9.06,1,10.1,8,.51,3.42,1.62,17.72,3,23.07,1.22,4.7,2.86,10.51,4.68,13.87a2,2,0,0,0,1.5,1.05c1.71.25,2.21,1.2,3.59,1.91,1.09.55,1.89.41,1.84.79a2.13,2.13,0,0,1-1.72,1.69,6.08,6.08,0,0,1-2-.13,11.34,11.34,0,0,0,3,2.72c2.67,1.72,3.1,3.4-1.12,5.65-2.65,1.41-5.13.72-8.41-4.64a43.34,43.34,0,0,1-3.3-6.22C155.77,242.29,153.68,237.25,152.81,233.41Z",
    style: {
      fill: "#995153"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.26,203.25h0c-5.91,2.05-6.33,5.46-7.81,9.46a13.73,13.73,0,0,0-.28,8.88l4.12,12.66a85.49,85.49,0,0,0-4.17,11.59c10.35,3.89,23.26-3.07,26.37-8.77.13-1.06-.67-8.91-1.16-14,1.82-5.76,2.3-9.24,1.53-12.52-1.43-6.09-7-10.91-9.41-10Z",
    style: {
      fill: "#28A745"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.91,244.24c-3.4,0-5.56-3.41-4.66-7.54a2.49,2.49,0,0,1,.11-.4c.66-2,2.09-2.17,2.09-2.17h0c-1.34-.67-2-2.25-2.29-4l-1.55-8.06a12,12,0,0,1,.32-4.27l-4.16-4.43-.77.82a13.56,13.56,0,0,0,.17,7.39l4.12,12.66a78.63,78.63,0,0,0-4.17,11.59c7.63,2.87,16.64-.16,22.1-4.23A28,28,0,0,1,139.91,244.24Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.29,172.39c1.39.57,3.13,4.14,3,12.65-.12,7.22-2.13,9.54-3.14,10.33s-3,1-4.86,1.16l.11,4.34s3.2,2.16,3,4.18-4.44,4.08-6.9,2.83a21,21,0,0,1-4.43-3.23.35.35,0,0,1-.1-.27V193.5s-1.11,1.56-3,.17a4.07,4.07,0,0,1-.89-5.43c1.21-1.76,3.46-2,4.33-.19,0,0,3-.69,7.06-4.35A18.3,18.3,0,0,0,150.29,172.39Z",
    style: {
      fill: "#995153"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.2,185.14a1.23,1.23,0,0,1-.74,1.18c-.43.14-.8-.16-.83-.67a1.23,1.23,0,0,1,.74-1.18C145.8,184.32,146.17,184.62,146.2,185.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.43,191.16l1.82.18a1.27,1.27,0,0,1-1.18,1.07C146.56,192.36,146.28,191.8,146.43,191.16Z",
    style: {
      fill: "#733b3c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.6,180.61l-1.59-.83c.29-.6.88-.9,1.32-.67A1.14,1.14,0,0,1,152.6,180.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.24,182.83a1.2,1.2,0,0,1-.73,1.18c-.44.15-.81-.15-.83-.67a1.23,1.23,0,0,1,.74-1.18C151.85,182,152.22,182.32,152.24,182.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "148.72 182.83 148.69 188.72 151.17 187.16 148.72 182.83",
    style: {
      fill: "#733b3c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.15,196.53c-2,.25-6.13,0-6.78-1.7a3.56,3.56,0,0,0,1.46,2c1.23.88,5.35,1.15,5.35,1.15Z",
    style: {
      fill: "#733b3c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.67,242.53c4.6-22.93,7.5-32.82,12.54-36.31a16.2,16.2,0,0,1,3.42-1.69c.69.26.76,1.77.89,2.75a24.12,24.12,0,0,1-2.62,13.13s-6.71,18.14-7.78,24.23c-.93,5.34-2,12-1.94,16.39a2.8,2.8,0,0,0,.74,1.93c1.24,1.21,1.24,2.44,2,3.93.63,1.16,1.31,1.47,1.11,1.82a1.57,1.57,0,0,1-2,.71,5.47,5.47,0,0,1-1.53-1.28,16.62,16.62,0,0,0,1.21,4.38c1.38,3.22,1,5.13-3.15,5-2.62-.1-4.27-2.18-4.67-9.36a66.18,66.18,0,0,1-.07-8.05C117.4,253,117.81,246.84,118.67,242.53Z",
    style: {
      fill: "#995153"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M164.87,217.88l-.06-2.93-3.48-2h0a1.09,1.09,0,0,0-1.11.11l-48.48,28a3.48,3.48,0,0,0-1.58,2.72v14.44a1.11,1.11,0,0,0,.45,1h0l3.48,2v-3.47l46.11-26.57a3.46,3.46,0,0,0,1.57-2.72v-10.6Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.81,215l-3.48-2h0a1.09,1.09,0,0,0-1.11.11l-48.48,28a3.14,3.14,0,0,0-1,1l4.93,2.85,46.12-26Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.21,243.05l48.48-28c.87-.5,1.58-.1,1.58.91v14.49a3.48,3.48,0,0,1-1.58,2.72l-48.48,27.94c-.87.51-1.57.1-1.57-.9V245.77A3.46,3.46,0,0,1,115.21,243.05Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "freepik--stars--inject-15--inject-140"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.83,244.4l.88,1.87a.22.22,0,0,0,.29.12l2-.76c.31-.12.44.32.21.75l-1.43,2.67a.93.93,0,0,0-.11.52L122,252c0,.39-.27.89-.55.86l-1.77-.22a.45.45,0,0,0-.35.21l-1.77,2.25c-.28.36-.61.23-.55-.21l.33-2.82a.4.4,0,0,0-.11-.39l-1.42-1c-.23-.16-.1-.75.21-1l2-1.52a.88.88,0,0,0,.29-.44l.88-2.9C119.28,244.34,119.69,244.1,119.83,244.4Z",
    style: {
      fill: "#28A745"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.81,238.68l.88,1.88a.22.22,0,0,0,.29.11l2-.76c.32-.12.44.32.21.75l-1.42,2.68a.89.89,0,0,0-.11.51l.33,2.43c.06.38-.27.89-.55.85l-1.76-.21a.41.41,0,0,0-.36.2l-1.76,2.26c-.28.35-.61.23-.56-.22l.34-2.81a.41.41,0,0,0-.11-.39l-1.43-1c-.23-.17-.1-.75.21-1l2-1.52a.94.94,0,0,0,.28-.45l.89-2.89C129.27,238.62,129.67,238.39,129.81,238.68Z",
    style: {
      fill: "#28A745"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.79,233l.89,1.87a.2.2,0,0,0,.28.11l2-.75c.31-.12.43.32.21.74l-1.43,2.68a.91.91,0,0,0-.11.52l.34,2.42c.05.39-.28.89-.56.86l-1.76-.22a.46.46,0,0,0-.36.2l-1.76,2.26c-.28.36-.61.23-.55-.22l.33-2.81a.42.42,0,0,0-.11-.39l-1.42-1c-.23-.16-.11-.75.21-1l2-1.52a1,1,0,0,0,.29-.45l.88-2.89C139.25,232.9,139.65,232.67,139.79,233Z",
    style: {
      fill: "#28A745"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.78,227.25l.88,1.87a.22.22,0,0,0,.29.12l2-.76c.31-.12.44.32.21.75l-1.42,2.67a.85.85,0,0,0-.11.52l.33,2.42c.06.39-.27.9-.55.86l-1.77-.22a.45.45,0,0,0-.35.21l-1.77,2.25c-.28.36-.6.23-.55-.21l.34-2.82a.42.42,0,0,0-.11-.39l-1.43-1c-.23-.16-.1-.75.21-1l2-1.52a.82.82,0,0,0,.29-.44l.88-2.89C149.23,227.19,149.64,227,149.78,227.25Z",
    style: {
      fill: "#28A745"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.76,221.53l.89,1.88a.2.2,0,0,0,.28.11l2-.76c.31-.12.43.32.21.75l-1.43,2.68a.89.89,0,0,0-.11.51l.34,2.43c.05.38-.28.89-.56.85l-1.76-.21a.42.42,0,0,0-.36.2l-1.76,2.26c-.28.35-.61.23-.56-.22l.34-2.81a.41.41,0,0,0-.11-.39l-1.43-1c-.22-.17-.1-.75.22-1l2-1.52a1,1,0,0,0,.29-.45l.88-2.89C159.22,221.47,159.62,221.24,159.76,221.53Z",
    style: {
      fill: "#28A745"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character--inject-15--inject-140"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M432.74,378.26c.66.27.79,1.53.84,4,0,1.89.36,5.2-1.87,5.8s-5.46.2-6.84-1.61c-1.72-2.26-2.87-4.25-5.34-7-2.14-2.4-4.46-4.65-5.27-8-.73-3,0-4.28,2-5.1,2.82-1.13,7.13,2.86,9.31,3.53C427.46,370.49,432.09,378,432.74,378.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.79,376l-.07,3.07a7.52,7.52,0,0,1-7.75,0c-.13-.3-.71-4.4-.71-4.4Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.51,395.38a51.26,51.26,0,0,1,1.24,5c.33,1.87.81,5,.12,6.36s-3.23,2.22-7.15,2.1c-2.55-.07-6.55,1.56-9.3,3s-8.68,2-11.63,1.57c-3.49-.48-7.06-2.59-7.59-4.05s.25-2.95,8.56-6.27c.08,0,11.53-3.47,15.61-7.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.58,392.06s-.06,2.28-.08,3.58-1.6,3.2-5.57,3c-2.79-.16-4.72-1-4.56-3.26l.08-3.31Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.7,335.3a82.65,82.65,0,0,0-3.26-16.06s1.41-13.75,2.23-26.81c.88-14.09.69-31.85,1-35.36,0,0-45.33-10.24-46.51,6.05s.5,57.89.88,65.06,1.47,13.55,2.69,25.2c1.2,11.49,4.69,38.66,4.69,38.66a10.74,10.74,0,0,0,10.13,0s3.94-32.55,3.79-40.82a70.44,70.44,0,0,0-2.73-18.12s1.17-13.44,2.2-25.12,2-17.28,2.25-22.37l1-.46s.54,20.2.92,27.38,1.36,14.08,3.13,27.44c1.54,11.59,6.35,36.14,6.35,36.14,5.14,2.93,8.31-.18,8.31-.18S436.88,345.35,435.7,335.3Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.09,285.63s11.17-5.19,16.81-10c0,0-5.3,7.12-12.11,10.17,0,0-3,25-2.94,24.53L414,285.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "405.35 192.63 407.7 207.52 421.12 206.84 419.56 189.42 405.35 192.63",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.9,198.35s7.35-2.61,11.34,4.07.68,18.39.68,18.39Z",
    style: {
      fill: "#28A745"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.3,206.08c-1.24-4.07-6.26-8.57-11.4-7.73-1.19.19-2.35.39-3.49.59-.61,2.51-7,4.45-13.61,2.9q-3,.78-5.44,1.6c-4.73,1.57-9.09,5.52-9.82,20.93,0,0-2.38,35.91-2.57,42.86,11.67,4.92,23.91,5,30.71,3.73,14.15-2.76,16-8.57,16-8.57s.77-25.84.6-37C436.11,215.89,436.14,208.87,435.3,206.08Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "362.87 181.54 334.92 196.13 348.81 234.1 374.89 219.49 362.87 181.54",
    style: {
      fill: "#28A745"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "361.59 185.26 338.14 197.5 350.43 230.15 372.31 217.89 361.59 185.26",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.64,188.78l-.45-1.16c-.26-.64-2.21-.26-4.36.86l-4.13,2.13c-2.16,1.11-3.7,2.54-3.45,3.18l.45,1.16Z",
    style: {
      opacity: 0.15
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.19,184.14c-.16-.4-1-.34-1.9.14l-1.62.88s-1-2.51-4.71-.78-2.87,4.65-2.87,4.65l-1.72.94c-.95.53-1.62,1.28-1.51,1.69l.21.74,14.4-7.52Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.63,185.82c-1.34.66-1.86,1-1.48,2s.85,1.94.85,1.94l-6.37,3.33s-.53-1.44-.76-2-.7-.82-1.71-.29l-.38-.4,10.05-5.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.91,188.85l-.45-1.17c-.25-.64-2.2-.25-4.36.86L348,190.67c-2.16,1.11-3.7,2.54-3.45,3.18L345,195Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.83,235.25s6.92-8.39,8.72-14.55a36.75,36.75,0,0,1-8.92,17.59Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.58,203.76c-5.35,1.6-8.61,1.89-14.52,11S366.78,240.87,365.5,243c-1.78,3-2.12,7.6-.58,10.37,1.44,2.58,4.89,1.06,10.75-4.08,5.67-5,17.64-18.66,17.64-18.66A97.1,97.1,0,0,0,400.58,203.76Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.58,203.76a41.18,41.18,0,0,0-7.74,2.45,13.93,13.93,0,0,0-6.58,4.54c-4.8,6.42-11.84,19.4-11.84,19.4s1.61,7.64,11.95,10.6c0,0,10-12,11.35-15C400.05,220.59,402.25,211.79,400.58,203.76Z",
    style: {
      fill: "#28A745"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.72,254.67c-5-.6-15.63-15.56-18.91-20.68a36.63,36.63,0,0,0-10-10.56c-5.24-3.86-4.47-9.81-2.19-15.25.79-1.89,3.47-.66,3.47-.66l.95,2.58,1.64,4.48c1.11,1,1.74,1.36,1.81,1.06.14-.58-.81-3-.79-5.5,0-3,2.14-1,2.77,0a37.27,37.27,0,0,1,2.23,5c1.06,2.7.62,5.44,1.91,7.28s18.51,18.35,18.51,18.35Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.41,174.35s-3.51,5.34-3.11,5.87,3,1,3,1Z",
    style: {
      fill: "#f28f8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.06,177.79a4.2,4.2,0,1,1,4.19-4.2A4.2,4.2,0,0,1,397.06,177.79Zm0-7.46a3.26,3.26,0,1,0,3.26,3.26A3.26,3.26,0,0,0,397.06,170.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.19,159.58c-7.13,1.51-9.18,4.64-9.85,15.95-.7,11.82.5,15.53,2.06,17.13,1,1.07,6.87,1.27,9.81.45,3.68-1,12-4,15.88-9.9,4.58-7,5.79-16.48.88-20.37C417.07,157.37,408.08,159,405.19,159.58Z",
    style: {
      fill: "#ffa8a7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "393.26 172.72 405.92 174.35 405.41 175.25 393.26 173.67 393.26 172.72",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.55,163.28l.22.21c1.37,1.3,3.12,2.12,4.55,3.36a10.59,10.59,0,0,1,3.24,5.14c.47,1.64.65,3.58,2.43,4.34,0,0,1.13-4.37,4.81-3.82s4.21,5.28,1.87,8.15-4.51,1.77-4.51,1.77.11,6.25,2.88,9.78c0,0,3.15,1,8.94-.21,3.56-.76,8.6-5.21,10.71-9.92,4.48-10,4.79-18.94-1.57-21.63-.69-4.59-4.31-6.65-8.43-7.6-6.16-1.41-11.93,2.25-18,.88-1.27-.28-2.52-.74-3.82-.9a.83.83,0,0,0-.44,0c-.31.16-.29.61-.2.94a8,8,0,0,0,1.8,3.29,18.84,18.84,0,0,1-6.91-.87A8.91,8.91,0,0,0,394.55,163.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.23,162l4.26-2.51a2.47,2.47,0,1,0-4.26,2.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.92,178.83l.13-5a2.48,2.48,0,1,0-.13,5Z",
    style: {
      fill: "#263238"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdmindash);
export default __webpack_public_path__ + "static/media/admindash.71a9ecd4ceed054352cd910b69de66b1.svg";
export { ForwardRef as ReactComponent };